module.exports = __webpack_public_path__ + "img/deng.91636ecf.png";